import React, { useMemo, useState } from "react";
import PdfGenerator from "./components/Pdfgenerator";
import Dropdown from 'react-bootstrap/Dropdown';
import { useGetMachineName } from "app/view/hooks/useGetMachineName";
import { useGetParameterName, useGetParameterNamesByIds } from "app/view/hooks/useGetParameterName";
import { useGetMaterialLink, useGetMaterialName, useGetMaterialNamesByIds } from "app/view/hooks/useGetMaterialById";
import { useRecoilValue } from "recoil"
import { CCPolyCostOfCo2PerPartFData } from "atoms/CCPolymer/CCPolyCo2Process";
import { WorkingHours, HighestIndexArray } from "atoms/General";
import { DebounceInput } from 'react-debounce-input';
import { ToastContainer } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import LineChartCapture from "./components/Pdfgenerator/LineChartCapture";
const ThirdReport = ({ 
  CO2e,
  machineDetails,
  machineImageUrl,

  totalJobsWithWorkingHours,
  totalJobsWithoutWorkingHours,
  PreviousScenarioState, staticData, cppData, currency, visualDonut, jobsPerWeek, totalJobs, singleJobTime, machineImage, psImage, cppSum, hotspotArray, hightlightKey, isHotSpotAvailable, scenariosData, scenarios,allMachineDetails, machineDetailsArray, scenarioTotalJobs, scenarioJobsLoading }) => {
  const [chartImage, setChartImage] = React.useState(null);

  const [savePdf, setSavePdf] = useState(false)
  const [typedocument, setTypeDocument] = useState()
  const costOfCo2pp = useRecoilValue(CCPolyCostOfCo2PerPartFData)
  const workingHours = useRecoilValue(WorkingHours)
  const highestIndexArray = useRecoilValue(HighestIndexArray)
  const parameterName = useGetParameterName(+staticData?.parameter_id?.value);
  const machineName = useGetMachineName(
    +staticData?.machine_id?.value
  );
  const materialId = +staticData?.material_id?.value;
  const materialName = useGetMaterialName(materialId);
  const materialLink = useGetMaterialLink(materialId);
  // Collect all unique material_ids and parameter_ids from scenarios
  const allMaterialIds = useMemo(() => {
    const materialIds = new Set();
    
    // Add material ID from staticData (default scenario)
    if (staticData?.material_id?.value) {
      const id = +staticData.material_id.value;
      if (id && !isNaN(id) && id > 0) {
        materialIds.add(id);
      }
    }
    
    // Add material IDs from all additional scenarios
    if (scenariosData) {
      Object.values(scenariosData).forEach((scenarioData) => {
        // Check both nested costData structure and direct material_id
        const materialIdValue = scenarioData?.costData?.material_id?.value ?? scenarioData?.material_id?.value;
        if (materialIdValue) {
          const id = +materialIdValue;
          if (id && !isNaN(id) && id > 0) {
            materialIds.add(id);
          }
        }
      });
    }
    
    return Array.from(materialIds);
  }, [staticData, scenariosData]);

  /**
   * Collect all unique parameter IDs from staticData and all scenarios
   * Why: Batch fetch parameter names to avoid multiple API calls and ensure
   * all parameter data is available for PDF generation across all scenarios
   */
  const allParameterIds = useMemo(() => {
    const parameterIds = new Set();
    
    // Add parameter ID from staticData (default scenario)
    if (staticData?.parameter_id?.value) {
      const id = +staticData.parameter_id.value;
      if (id && !isNaN(id) && id > 0) {
        parameterIds.add(id);
      }
    }
    
    // Add parameter IDs from all additional scenarios
    if (scenariosData) {
      Object.values(scenariosData).forEach((scenarioData) => {
        // Check both nested costData structure and direct parameter_id
        const parameterIdValue = scenarioData?.costData?.parameter_id?.value ?? scenarioData?.parameter_id?.value;
        if (parameterIdValue) {
          const id = +parameterIdValue;
          if (id && !isNaN(id) && id > 0) {
            parameterIds.add(id);
          }
        }
      });
    }
    
    return Array.from(parameterIds);
  }, [staticData, scenariosData]);

  // Fetch all material and parameter names
  const { materialNamesMap, materialNamesArray } = useGetMaterialNamesByIds(allMaterialIds);
  const { parameterNamesMap, parameterNamesArray } = useGetParameterNamesByIds(allParameterIds);


  const [show, setShow] = useState(false);

  const [pdfName, setPdfName] = useState("")
  const [creatorName, setCreatorName] = useState("");
  const [creatorTitle, setCreatorTitle] = useState("");
  const [creatorMobile, setCreatorMobile] = useState("");
  const [creatorEmail, setCreatorEmail] = useState("");

  const [isDownloading, setIsDownloading] = useState(false);

  const handleClose = () => setShow(false);
  const getAccountExportDefaults = () => ({
    name: sessionStorage.getItem("user_name") || "",
    title: sessionStorage.getItem("user_title") || "",
    mobile: sessionStorage.getItem("user_mobile") || "",
    email: sessionStorage.getItem("user_email") || "",
  });

  const applyIfEmpty = (setValue, nextValue) => {
    if (!nextValue) return;
    setValue((prev) => (prev?.trim() ? prev : nextValue));
  };

  const openExportModal = () => {
    const defaults = getAccountExportDefaults();
    applyIfEmpty(setCreatorName, defaults.name);
    applyIfEmpty(setCreatorTitle, defaults.title);
    applyIfEmpty(setCreatorMobile, defaults.mobile);
    applyIfEmpty(setCreatorEmail, defaults.email);
    setShow(true);
  };
  const max = Math.max(...highestIndexArray);
  const highestIndex = highestIndexArray.indexOf(max);
  const initialDocumentState = () => {
    setTypeDocument(undefined);
    setPdfName("")
    setCreatorName("")
    setCreatorTitle("")
    setCreatorMobile("")
    setCreatorEmail("")
    setSavePdf(false)
    setIsDownloading(false);

  }
  console.log("staticData", visualDonut);
  const technology_name = sessionStorage.getItem("technologyName")
  const isPptEnabled = sessionStorage.getItem("is_ppt_enabled") === "true";
  const canDownloadPpt = isPptEnabled;
  const isDownloadDisabled = !pdfName.trim() || !creatorName.trim() || isDownloading;
  return (
    <>
      <LineChartCapture 
        onCapture={setChartImage} 
        costData={staticData} 
        cppData={cppData}
        currency={currency}
        scenariosData={scenariosData}
        scenarios={scenarios}
      />

      <ToastContainer />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {typedocument === 0 ? "Enter PDF Name" : "Enter PPT Name"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="input-section">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => {
                setPdfName(e.target.value);
              }}
              onWheel={e => e.target.blur()}
              placeholder="Document name (required)"
              value={pdfName}
            />
          </div>
          <div className="input-section mt-3">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => setCreatorName(e.target.value)}
              onWheel={e => e.target.blur()}
              placeholder="Creator name (required)"
              value={creatorName}
            />
          </div>
          <div className="input-section mt-3">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => setCreatorTitle(e.target.value)}
              onWheel={e => e.target.blur()}
              placeholder="Title (optional)"
              value={creatorTitle}
            />
          </div>
          <div className="input-section mt-3">
            <DebounceInput
              type="text"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => setCreatorMobile(e.target.value)}
              onWheel={e => e.target.blur()}
              placeholder="Mobile (optional)"
              value={creatorMobile}
            />
          </div>
          <div className="input-section mt-3">
            <DebounceInput
              type="email"
              className="user-input"
              debounceTimeout={500}
              onChange={(e) => setCreatorEmail(e.target.value)}
              onWheel={e => e.target.blur()}
              placeholder="Email (optional)"
              value={creatorEmail}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-center align-items-center w-100 gap-12 '>
            <button className="button1 button btn-black  m-0" onClick={handleClose}>
              Close
            </button>
            <Button
              disabled={isDownloadDisabled}
              className={`button1 button mt-0 ${isDownloadDisabled ? "btn-secondary" : "btn-primary"}`}
              style={{
                cursor: isDownloadDisabled ? "not-allowed" : "pointer",
                pointerEvents: isDownloadDisabled ? "none" : "auto",
                opacity: isDownloadDisabled ? 0.7 : 1,
                backgroundColor: isDownloadDisabled ? "#adb5bd" : undefined,
                borderColor: isDownloadDisabled ? "#adb5bd" : undefined,
              }}
              onClick={() => {
                setIsDownloading(true);
                setSavePdf(true);
                handleClose();
              }}
            >
              {isDownloading && (
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: 8 }}
                />
              )}
              {isDownloading ? "Preparing..." : "Download"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* <div className="reports-section"> */}
      <div className="d-flex flex-row justify-content-center align-items-center">
        <Dropdown>
          {/* <Button
            className="selection-button step-button"
            id="dropdown-basic"
            onClick={() => {
              setTypeDocument(0);
              handleShow();
            }}
          >
            Download Report
          </Button> */}
          {/* TODO... */}
          <Dropdown.Toggle
            className="button1 button btn-black "
            id="dropdown-basic"
            style={{ backgroundColor: "black" }}
          >
            <div className="d-flex gap-8 mr-8">
              {isDownloading ? (
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: 8 }}
                />
              ) : (
                <>
                  <img alt="" src="../assets/download.svg" />

                  <span>Download</span>
                </>
              )}
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu >
            <Dropdown.Item onClick={() => { setTypeDocument(0); openExportModal() }}>As PDF</Dropdown.Item>
            {canDownloadPpt && (
              <Dropdown.Item onClick={() => { setTypeDocument(1); openExportModal() }}>As PPT</Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {
        savePdf && chartImage && (
          <PdfGenerator
            totalJobsWithWorkingHours={totalJobsWithWorkingHours}
            totalJobsWithoutWorkingHours={totalJobsWithoutWorkingHours}
            chartImage={chartImage}
            creatorName={creatorName}
            creatorTitle={creatorTitle}
            creatorMobile={creatorMobile}
            creatorEmail={creatorEmail}
            formFields={staticData}
            pdfName={pdfName}
            typeDocument={typedocument}
            machineName={machineName}
            materialName={materialName}
            parameterName={parameterName}
            cppData={cppData}
            costOfCo2pp={costOfCo2pp}
            currency={currency}
            visualDonut={visualDonut}
            jobsPerWeek={jobsPerWeek}
            totalJobs={totalJobs}
            singleJobTime={singleJobTime}
            machineImage={machineImage}
            psImage={psImage}
            cppSum={cppSum}
            initialDocumentState={initialDocumentState}
            workingHours={workingHours}
            hotspotArray={hotspotArray}
            highestIndex={highestIndex}
            hightlightKey={hightlightKey}
            isHotSpotAvailable={isHotSpotAvailable}
            technology_name={technology_name}
            CO2e={CO2e}
            machineDetails={machineDetails}
            machineImageUrl={machineImageUrl}
            materialLink={materialLink}
            scenariosData={scenariosData}
            scenarios={scenarios}
            allMachineDetails={allMachineDetails}
            machineDetailsArray={machineDetailsArray}
            materialNamesMap={materialNamesMap}
            materialNamesArray={materialNamesArray}
            parameterNamesMap={parameterNamesMap}
            parameterNamesArray={parameterNamesArray}
            scenarioTotalJobs={scenarioTotalJobs}
          />
        )}
      {/* </div> */}
    </>
  );
};

export default ThirdReport;
